export default __webpack_public_path__ + "static/media/APACHE RTR 200 4V_4.f0518936.webp";